import { AvObserver } from "./av_observer";
import { BreakoutAudioObserver } from "./breakout_audio_observer";
import { CaptionsObserver } from "./captions_observer";
import { ChatMessageObserver } from "./chat_message_observer";
import { ClassEventObserver } from "./class_event_observer";
import { ConfettiObserver } from "./confetti_observer";
import { FatalErrorObserver } from "./fatal_error_observer";
import { HandRaiseObserver } from "./hand_raise_observer";
import { ParticipantBarObserver } from "./participant_bar_observer";
import { PubsubMessageObserver } from "./pubsub_message_observer";
import { ReactionObserver } from "./reaction_feed";
import { RecordingObserver } from "./recording_observer";
import { ResourceObserver } from "./resource_observer";
import { SpeechDetectorObserver } from "./speech_detector_observer";
import { VisibilityObserver } from "./visibility_observer";

import { OverlayErrorBoundary } from "components/error_boundary";
import { useCapability } from "hooks/capabilities";
import { useAppSelector } from "hooks/redux_hooks";
import { useIsMobile } from "hooks/use_is_mobile";
import { CapabilityType } from "shared/types";
import { classroomSelectors } from "store";

function Observers() {
  const isPresentationView = useAppSelector(classroomSelectors.selectIsPresentationView());
  const isMobile = useIsMobile();
  const isInPerson = useAppSelector(classroomSelectors.selectIsInPersonClass());
  const isLargeClass = useAppSelector(classroomSelectors.selectIsLargeClass());
  const canControlClassroom = useCapability(CapabilityType.CAN_CONTROL_CLASSROOM);
  const canPlaySounds = useAppSelector(classroomSelectors.selectCurrentUserCanPlaySounds());
  const isAvEnabled = useAppSelector(classroomSelectors.selectCurrentUserIsAvEnabled());

  return (
    <>
      <OverlayErrorBoundary>
        <PubsubMessageObserver />
      </OverlayErrorBoundary>
      {canPlaySounds && (
        <OverlayErrorBoundary>
          <BreakoutAudioObserver />
        </OverlayErrorBoundary>
      )}
      <CaptionsObserver />
      <OverlayErrorBoundary>
        <ChatMessageObserver />
      </OverlayErrorBoundary>
      <OverlayErrorBoundary>
        <ClassEventObserver />
      </OverlayErrorBoundary>
      <OverlayErrorBoundary>
        <ConfettiObserver />
      </OverlayErrorBoundary>
      <OverlayErrorBoundary>
        <RecordingObserver />
      </OverlayErrorBoundary>
      {isAvEnabled && <ParticipantBarObserver />}
      {((!isMobile && isInPerson) || isLargeClass) && (
        <OverlayErrorBoundary>
          <ReactionObserver />
        </OverlayErrorBoundary>
      )}
      {canControlClassroom && (
        <OverlayErrorBoundary>
          <ResourceObserver />
        </OverlayErrorBoundary>
      )}
      {canControlClassroom && !isPresentationView && (
        <OverlayErrorBoundary>
          <HandRaiseObserver />
        </OverlayErrorBoundary>
      )}
      {!isMobile && !isInPerson && <AvObserver />}
      {!isMobile && !isInPerson && (
        <OverlayErrorBoundary>
          <SpeechDetectorObserver />
        </OverlayErrorBoundary>
      )}
      {!isMobile && !isInPerson && <FatalErrorObserver />}
      <VisibilityObserver />
    </>
  );
}

export { Observers };
